import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const userList = createAsyncThunk('user/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `user`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const userDetails = createAsyncThunk('user/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `user/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addUser = createAsyncThunk('user/add', async (data) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "role_id", data?.values?.role_id
    )
    bodyFormData.append(
        "first_name", data?.values?.fname
    )
    bodyFormData.append(
        "last_name", data?.values?.lname
    )
    bodyFormData.append(
        "gender", data?.values?.gender
    )
    bodyFormData.append(
        "user_name", data?.values?.username
    )
    bodyFormData.append(
        "password", data?.values?.password
    )
    bodyFormData.append(
        "user_mobile", data?.values?.mobile
    )
    bodyFormData.append(
        "user_email", data?.values?.email
    )
    bodyFormData.append(
        "dob", data?.values?.dob && moment(data?.values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    {
        data?.values?.profile &&
            bodyFormData.append(
                "user_profile", data.values.profile
            )
    }
    bodyFormData.append(
        "status", data?.values?.status
    )

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'user',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "profile", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateUser = createAsyncThunk('user/update', async (data) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "user_id", data?.values?.id
    )
    bodyFormData.append(
        "role_id", data?.values?.role_id
    )
    bodyFormData.append(
        "first_name", data?.values?.fname
    )
    bodyFormData.append(
        "last_name", data?.values?.lname
    )
    bodyFormData.append(
        "gender", data?.values?.gender
    )
    bodyFormData.append(
        "user_name", data?.values?.username
    )
    bodyFormData.append(
        "user_mobile", data?.values?.mobile
    )
    bodyFormData.append(
        "user_email", data?.values?.email
    )
    bodyFormData.append(
        "dob", data?.values?.dob && moment(data?.values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    {
        data?.values?.profile &&
            bodyFormData.append(
                "user_profile", data.values.profile
            )
    }
    bodyFormData.append(
        "status", data?.values?.status
    )

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_user',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "profile", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delUser = createAsyncThunk('user/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `user/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const user = createSlice({
    name: 'user',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(userList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(userDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default user.reducer;